import WelcomeScreenLightbox from './components/WelcomeScreenLightbox'
import {bindActionCreators} from "redux"
import {connect} from '../../redux/utils'
import {getDemoDataStage, getHeight, getLoading, getShowExternalContent, getSize, getStage, getUrl, getWidth} from './selectors'
import {openLightbox, closeLightbox, sendMessage} from './actions'
import $ from '../../alias/jquery'
import {DemoDataStageType, WelcomeScreenFrameId} from './constants'
import DemoDataComponent from './components/DemoDataComponent'
import LoadingMoire from '../../LoadingMoire'
import messageResource from '../../messageResource'
import StateComponent from '../../StateComponent'

class WelcomeScreenContainer extends StateComponent {
    constructor({
            $containerEl = $('body'),
            openLightbox,
            closeLightbox,
            sendMessage,
        }
    ) {
        super($containerEl)
        this.state = {
            loading: false,
            showExternalContent: false,
            demoDataStage: DemoDataStageType.IDLE,
            url: '',
            width: 0,
            height: 0,
        }

        this.params = {
            openLightbox,
            closeLightbox,
            sendMessage,
        }

        this.onStatePropertyChanged('loading', loading => {
            this.pageLoadingMoire.toggle(loading)
        })

        this.onStatePropertyChanged('showExternalContent', showExternalContent => {
            if (showExternalContent) {
                this.lightbox.show()
            } else {
                this.lightbox.hide()
            }
        })

        this.onStatePropertyChanged('demoDataStage', demoDataStage => {
            if (demoDataStage === DemoDataStageType.ACTIVE) {
                this.demoDataLoader.show()
            }
            if (demoDataStage === DemoDataStageType.ERROR) {
                this.demoDataLoader.hide()
            }
            this.demoDataLoader.setState({stage: demoDataStage})
        })

        this.onStatePropertyChanged('url', url => {
            this.lightbox.changeUrl(url)
        })

        this.onAnyStatePropertyChanged(['width', 'height'], () => {
            this.lightbox.changeSize({
                width: this.state.width,
                height: this.state.height,
            })
        })
    }

    init() {
        this.lightbox = new WelcomeScreenLightbox({
            onCloseCallback: this.params.closeLightbox,
            iframeLoadCallback: this.params.sendMessage,
            frameName: WelcomeScreenFrameId,
        })
        this.lightbox.init()

        this.pageLoadingMoire = new LoadingMoire({
            additionalClass: 'welcomeScreenLoadingMoire',
            additionalSpinnerSettings: {
                radius: 17,
                length: 13,
                width: 4
            },
            delay: 0,
        }).init($('body'))

        this.demoDataLoader = new DemoDataComponent({
            label: messageResource.getMessage('welcome_screen.load_demo_data.label')
        })
        this.demoDataLoader.init($('body'))

        this.params.openLightbox()
    }
}

export default connect(
    (state) => ({
        loading: getLoading(state),
        showExternalContent: getShowExternalContent(state),
        demoDataStage: getDemoDataStage(state),
        url: getUrl(state),
        width: getWidth(state),
        height: getHeight(state),
    }),
    dispatch => bindActionCreators({
        openLightbox,
        closeLightbox,
        sendMessage,
    }, dispatch)
)(WelcomeScreenContainer)


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/WelcomeScreenContainer.js